import React, {useContext} from 'react';
import {SheetContext} from '../../context';
import ExpenseList from './ExpenseList';
import TabNavBar from "../../components/TabNavBar";
import Spinner from "../../components/Spinner";

export function ExpenseScreen({data, isLoading, migrating, migrationMessage}) {
  if (migrating) {
    return <div className="splash-screen">
      <Spinner />
      <div className="migration-message">{migrationMessage}</div>
    </div>
  }
  return <>
    <ExpenseList data={data}
                 isLoading={isLoading} />
    <TabNavBar />
  </>
}
export default function ExpenseScreenWrapper() {
  const ctx = useContext(SheetContext);
  const { expenses, expensesLoading, migrating, migrationMessage } = ctx;

  return <ExpenseScreen
    data={expenses}
    migrating={migrating}
    migrationMessage={migrationMessage}
    isLoading={expensesLoading} />
}
